import { rd } from '@passionware/monads';
import { useState } from 'react';
import type { UserPreferencesService } from 'v5/services/front/UserPreferencesService/UserPreferencesService';
import type { ResourcePickerView } from './ResourcePickerResults';

/**
 * The picker's List / Grid, the user's own and the same wherever resources are added; kept as an
 * entity list's layout (its grid is the picker's gallery). Without the service, kept while mounted.
 */
export function useResourcePickerView(services: {
  userPreferencesService?: UserPreferencesService;
}) {
  const [local, setLocal] = useState<ResourcePickerView>('list');
  const layout =
    services.userPreferencesService?.forEntityListLayout('resource-picker');
  const value = layout?.useValue();
  if (!layout || !value) return { view: local, onViewChange: setLocal };
  return {
    view: rd.mapOrElse(
      value,
      ({ viewMode }): ResourcePickerView =>
        viewMode === 'grid' ? 'gallery' : 'list',
      'list'
    ),
    onViewChange: (view: ResourcePickerView) =>
      layout.setValue({
        ...rd.getOrThrow(value),
        viewMode: view === 'gallery' ? 'grid' : 'list'
      })
  };
}
